<template>

  <div class="relativecls">

    <div class="checkRenkei relativecls">
      <b-form-checkbox id="renkeichk" v-model="l_renkei" size="sm" switch switch-variant="outline-primary">
      <b>連携{{renkeiWord}}</b>：判定に応じてKit制御
      </b-form-checkbox>
      <div class="set-action-conf" v-show="l_renkei">
        <b-icon icon="blank"></b-icon><b-link @click="modalActConf" size="sm"><b-icon icon="gear-fill"></b-icon>設定</b-link>
      </div>
    </div>

    <!-- Set Kit IP-Address -->
    <b-input-group prepend="Kit-IP" size="sm" class="inputip" v-show="l_renkei">
    <b-form-input v-model="kitaddr" :state="controlKits.ipstate" placeholder="192.168.x.xxx" ></b-form-input>
    </b-input-group>

    <!-- Set Action -->
    <div id="outact" class="action-drop" v-if="l_renkei">
      <div v-for="inp of inputs" v-bind:key="inp.id" class="action-input">
        <b-input-group size="sm">
          <b-input-group-text slot="prepend">{{inp.name}}</b-input-group-text>
          <b-form-select :id="`setact${inp.id}`" v-model="inp.act" @change="updateAct(inp.id)">
            <b-form-select-option value="0"><b-icon icon="gear-fill"></b-icon>【制御なし】</b-form-select-option>
            <b-form-select-option v-for="gact of setActions" v-bind:key="gact.no" :selected="gact.no==inp.act" :value="gact.no">{{gact.act}}</b-form-select-option>
          </b-form-select>
        </b-input-group>
      </div>
    </div>

  <!-- modal Action Set Config-->
  <div class="modal-overlay" v-if="modalActConfShow">
    <div class="modal-content">
      <div class="modalpad">
        <h5>Kit連携Action制御 設定変更</h5>
        <br/>
        <table class="table table-striped addTable">
          <thead>
            <tr><th>No</th><th>Action名</th><th>制御URL</th><th>削除</th></tr>
          </thead>
          <tbody>
            <tr v-for="gact of setActions" v-bind:key="gact.no">
              <td>{{gact.no}}</td>
              <td><b-form-input :id="`actconf-act${gact.no}`" v-model="gact.act" placeholder="Enter Action名">{{gact.act}}</b-form-input></td>
              <td><b-form-input :id="`actconf-url${gact.no}`" v-model="gact.url" placeholder="Enter 制御URL">{{gact.url}}</b-form-input></td>
              <td><b-icon icon="trash" font-scale="1.2" @click="delActConf(gact.no)" class="color-gray"></b-icon></td>
            </tr>
          </tbody>
        </table>
        <br/>
        <div>
          <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">Cancel</b-button>
          <b-button variant="outline-primary" size="sm" class="btnw" @click="addActConf()">追加</b-button>
          <b-button variant="outline-primary" size="sm" class="btnw" @click="setActConf()">設定</b-button>
        </div>
      </div>
    </div>
  </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'outaction',
  data () {
    return {
      btnvariant1: 'primary',
      btnvariant2: 'outline-primary',
      seledAction: '',
      vmodels: [],
      modalActConfShow: false
    }
  },
  components: {
  },
  computed: {
    ...mapState([ 'inputs', 'setActions', 'controlKits' ]),
    kitaddr: {
      get () {
        return this.controlKits.kitip
      },
      set (value) {
        const checkFlag = Boolean(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value))
        this.$store.dispatch('updContkit', {
          renkei: this.controlKits.renkei,
          s_ip: value,
          s_st: checkFlag
        })
      }
    },
    l_renkei: {
      get () {
        return this.controlKits.renkei
      },
      set (value) {
        this.$store.dispatch('updContkit', {
          renkei: value,
          s_ip: this.controlKits.kitip,
          s_st: this.controlKits.ipstate
        })
      }
    },
    renkeiWord () {
      if (this.controlKits.renkei) {
        return 'ON'
      } else {
        return 'OFF'
      }
    }
  },
  methods: {
    setAction () {
    },
    updateAct (actNum) {
      const actKey = 'setact' + actNum
      const actVal = document.getElementById(actKey).value
      this.$store.dispatch('updAction', {
        upd_id: actNum,
        upd_act: actVal
      })
    },
    modalActConf () {
      this.modalActConfShow = true
    },
    setActConf () {
      var setVal = []
      for (let key in this.setActions) {
        const actKey = 'actconf-act' + this.setActions[key].no
        const urlKey = 'actconf-url' + this.setActions[key].no
        const actVal = document.getElementById(actKey).value
        const urlVal = document.getElementById(urlKey).value
        const eachVal = { no: this.setActions[key].no, act: actVal, url: urlVal }
        setVal.push(eachVal)
      }
      this.$store.dispatch('setActConf', setVal)
      this.cancelModal()
    },
    addActConf () {
      this.$store.dispatch('addActConf')
    },
    delActConf (delNum) {
      this.$store.dispatch('delActConf', delNum)
    },
    cancelModal () {
      this.modalActConfShow = false
    }
  },
  mounted () {
  }

}
</script>
<style scoped>
.checkRenkei {
  margin: 0 0 0 10px;
  text-align: left;
}
.inputip {
  text-align: center;
  margin: 0 0 10px 16px;
  width: 185px;
  position: absolute;
  top: -5px;
  right: 10px;
}
.action-drop {
  padding: 10px;
}
.action-input {
  display: inline-block;
  width:220px;
  margin: 7px;
}
.set-action-conf  {
  position: absolute;
  top: 2px;
  left: 222px;
  font-size: 80%;
}
.modalpad {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/OutAction.vue